import React from 'react';
import {
  Box,
  Button,
  Icon,
  Illustration,
  Typography,
} from '@saviynt/design-system';

import testIds from '../../constants/testIds';
import useLocalization from '../../hooks/use-localize';

import './IntegrationPageError.css';

interface IntegrationPageErrorProps {
  showBack?: boolean;
  handleBackButtonCallback?: () => void;
  illustrationKind: string;
  heading: string;
  subHeading: string;
  reload: () => Promise<void>;
}

/**
 * Discovery Landing Error Component
 */
function IntegrationPageError({
  showBack,
  handleBackButtonCallback,
  illustrationKind,
  heading,
  subHeading,
  reload,
}: IntegrationPageErrorProps) {
  const formatMessage = useLocalization();

  const handleReload = async () => {
    await reload();
  };

  const handleBack = () => {
    if (handleBackButtonCallback) {
      handleBackButtonCallback();
    } else {
      window.history.back();
    }
  };

  return (
    <Box>
      {showBack && (
        <Box className='back'>
          <Button
            dataTestId='intergration-error-page-button'
            type='button'
            kind='ghost'
            size='large'
            leftIcon={<Icon kind='ChevronLeft' />}
            onClick={handleBack}>
            {formatMessage('INTEGRATIONS.DISCOVERY.BACK')}
          </Button>
        </Box>
      )}

      <div className='IntegrationPageError'>
        <section className='IntegrationPageError-Container'>
          <Box className='IntegrationPageError-Container-Icon'>
            <Illustration kind={illustrationKind} />
          </Box>
          <Box className='IntegrationPageError-Container-heading'>
            <Typography kind='h1'>{formatMessage(heading)}</Typography>
          </Box>
          <Box className='IntegrationPageError-Container-SubHeading'>
            <Typography kind='body1' color='--color-foreground-neutral-subtle'>
              {formatMessage(subHeading)}
            </Typography>
          </Box>
          <Box className='IntegrationPageError-Container-Reload'>
            <Button
              dataTestId={
                testIds.DISCOVERY_INTEGRATION_ERROR_PAGE_RELOAD_BUTTON
              }
              onClick={handleReload}
              type='button'
              kind='filled'
              size='large'>
              {formatMessage('INTEGRATIONS.DISCOVERY.ERROR.RELOAD')}
            </Button>
          </Box>
        </section>
      </div>
    </Box>
  );
}

// ✅ Default props for optional values
IntegrationPageError.defaultProps = {
  showBack: false,
  handleBackButtonCallback: undefined,
};

export default IntegrationPageError;
